import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';
import { locationShape } from 'react-router';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import styles from './Users.scss';
import UserRow from 'part11/components/UserRow/UserRow';
import SearchBar from 'components/common/SearchBar/SearchBar';
import ListControls  from 'components/common/Layout/ListControls';
import { setActionButton, clearActionButton, buildActionButtonProperty } from 'common/actions/actionButtonActions';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { usersFromInstitutionsSelector } from 'part11/selectors/sdfa';
import {
    loadUsers,
    getTotalUsers,
    clearUsersScene,
    sortOptions,
    sortOrderOptions,
    filterOptions,
    DEFAULT_LIMIT,
    INITIAL_OFFSET,
} from 'part11/actions/users';
import { SortingOptions, SortingOption } from 'components/common/SearchBar/SortingOptions';
import { newDoaStudyFlowAccess } from 'common/features/predicates';


export class Users extends Component {

    constructor(props) {
        super(props);

        const createPath =  '/admin/users/create';
        this.actionButtonProperty = buildActionButtonProperty('Create User', createPath);

        this.state = {
            sort: 'last_name',
            order: 'ASC',
            filter: 'ACTIVE',
            // registration status
            filter2: null,
        };
    }

    loadData(reset=false) {
        if (isNaN(this.props.totalUsers)) {
            this.props.getTotalUsers(this.props.institutionId);
        }
        const { query } = this.props.location;
        const search = lodash.cloneDeep(query);
        search.limit = this.props.limit;
        search.offset = reset ? INITIAL_OFFSET : this.props.offset;
        search.reset = reset;
        this.props.loadUsers(this.props.institutionId, null, search);
    }

    componentDidMount() {
        this.props.setActionButton(this.actionButtonProperty);
        this.loadData(true);
    }

    componentWillReceiveProps(nextProps) {
        const currentLocation = this.props.location;
        const nextLocation = nextProps.location;

        if (!lodash.isEqual(currentLocation.query, nextLocation.query)) {
            const search = lodash.cloneDeep(nextLocation.query);
            search.reset = true;
            search.offset = 0;
            this.props.loadUsers(this.props.institutionId, null, search);
        }
    }

    componentWillUnmount() {
        this.props.clearActionButton();
        this.props.clearUsersScene();
    }

    buildUsersList() {
        const { users, isNewDoaEnabled } = this.props;
        const hasMoreUsers = this.props.hasMoreUsers;

        if (this.props.isInitialLoad) {
            return <LoadingStatus  key={1} itemName='Users' loading={true} filterQuery={false}/>;
        }

        return (
            <InfiniteScroll
                key={0}
                loadMore={lodash.debounce(this.onScrollToBottom.bind(this), 100)}
                hasMore={hasMoreUsers}
                loader={<LoadingStatus key={1} itemName='Users' loading={true} filterQuery={false}/>}
                useWindow={false}
            >
                {lodash.values(users).map((user, index) => {
                    return <UserRow
                        user={user}
                        key={index}
                        isNewDoaEnabled={isNewDoaEnabled}
                        institutionId={this.props.institutionId} />;
                })
                }
            </InfiniteScroll>
        );
    }

    getUserListControls() {
        const { filter2Options } = this.props;
        const { sort, order, filter, filter2 } = this.context.location.query;

        const sortOptionsSortingOptions = this.createSortingOptions(sortOptions, 'sort');
        const currentSort = sort ? sort : this.state.sort;
        const sortOptionsDisplay = lodash.find(sortOptions, {'gqlName': currentSort}).displayName;

        const sortOrderOptionsSortingOptions = this.createSortingOptions(sortOrderOptions, 'order');
        const currentOrder = order ? order : this.state.order;
        const sortOrderDisplay = lodash.find(sortOrderOptions, {'gqlName': currentOrder}).displayName;

        const filterSortingOptions = this.createSortingOptions(filterOptions, 'filter');
        const currentFilter = filter ? filter : this.state.filter;
        const filterOptionsDisplay = lodash.find(filterOptions, {'gqlName': currentFilter}).displayName;

        const filter2SortingOptions = this.createSortingOptions(filter2Options, 'filter2');
        const currentFilter2 = filter2 ? filter2 : this.state.filter2;
        const filter2Object = lodash.find(filter2Options, {'gqlName': currentFilter2});
        const filter2OptionsDisplay = filter2Object ? filter2Object.displayName : 'All Registration Statuses';

        return (
            <ListControls>
                <SearchBar ref='UsersSearchBar' placeholder='Search Users' searchFunction={this.performSearch.bind(this)} />
                <SortingOptions>
                    <SortingOption label="Show" activeText={ filterOptionsDisplay } options={ filterSortingOptions }/>
                    <SortingOption label="Show" activeText={ filter2OptionsDisplay } options={ filter2SortingOptions }/>
                    <SortingOption label="Sort by" activeText={ sortOptionsDisplay } options={ sortOptionsSortingOptions }/>
                    <SortingOption label="" activeText={ sortOrderDisplay } options={ sortOrderOptionsSortingOptions }/>
                </SortingOptions>
            </ListControls>
        );
    }

    createSortingOptions(options, keyName) {
        return options.map((option) => {
            return {
                label: option.displayName,
                handler: this.createChangeHandler.call(this, keyName, option.gqlName),
            };
        });
    }

    createChangeHandler(key, value) {
        return (function onChangeHandler(){
            const updateObject = {};
            updateObject[key] = value;
            this.setState(updateObject);
            const { location, router } = this.context;
            const newLocation = lodash.merge({}, location, { query: updateObject });
            router.replace(newLocation);
        }).bind(this);
    }

    performSearch(query = '') {
        const { location, router } = this.context;
        const newLocation = lodash.merge({}, location, { query: { q : query } });
        router.replace(newLocation);
    }


    onScrollToBottom() {
        const { isLoading } = this.props;
        if ( isLoading ) { return false; }
        this.loadData();
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.userList}>
                    { this.getUserListControls() }
                    { this.buildUsersList() }
                </div>
            </div>
        );
    }
}

Users.contextTypes = {
    router: PropTypes.object.isRequired,
    location: locationShape.isRequired,
    store: PropTypes.any
};


export default connect((state, props) => {

    const filter2Options = lodash.get(state, 'app.search.filter2Options', []);
    const institutionId = props.params.id || state.me.institution.id;
    let users = {};
    if (props.params && props.params.id) {
        let institutionId = props.params.id;
        users = usersFromInstitutionsSelector(state, institutionId);
    } else {
        users = lodash.get(state, 'users', {});
    }

    const limit = lodash.get(state, 'adminUsers.limit', DEFAULT_LIMIT);
    const offset = lodash.get(state, 'adminUsers.offset', INITIAL_OFFSET);
    const hasMoreUsers = lodash.get(state, 'adminUsers.hasMoreUsers', true);
    const isLoading = lodash.get(state, 'adminUsers.isLoading', true);
    const isInitialLoad = isLoading && offset < limit;
    const totalUsers = lodash.get(state, 'adminUsers.totalUsers', NaN);
    const isNewDoaEnabled = newDoaStudyFlowAccess(state);

    return {
        filter2Options,
        institutionId,
        users,
        limit,
        offset,
        hasMoreUsers,
        isInitialLoad,
        isLoading,
        totalUsers,
        isNewDoaEnabled,
    };
}, {
    loadUsers: lodash.throttle(loadUsers, 10),
    clearUsersScene,
    setActionButton,
    clearActionButton,
    getTotalUsers,
})(Users);
